export const API_URL =
  (import.meta.env.VITE_API_URL as string) ??
  "https://aichat.miniapps.aitu.dev/aichat/v1";

export const MEDIA_HOST =
  (import.meta.env.VITE_MEDIA_HOST as string) ??
  "https://media.aitu.dev/api/v2/media";

export const MINI_APP_ID = import.meta.env.VITE_MINI_APP_ID as string;

export const BRANCH_API_KEY = import.meta.env.VITE_BRANCH_API_KEY as string;
